import React from 'react';
import { useFela } from '../..';
import ThemeProps from '../../Theme/ThemeProps';

export interface Props {
  children: React.ReactNode;
  /** Boolean, der wenn `true`, das scrollen im LayerContent erlaubt. */
  scrollable?: boolean;
  /** Boolean, der wenn `true`, den Innenabstand entfernt.  */
  noPadding?: boolean;
  style?: object;
}

const contentStyle = ({ scrollable }: { scrollable: Props['scrollable'] }) => ({
  boxSizing: 'border-box',
  flex: '1 1 auto',
  extend: [
    {
      condition: scrollable,
      style: {
        WebkitOverflowScrolling: 'touch', // Add iOS momentum scrolling.
        /**
         * CHECK: Maybe use `scroll` if behavior on iOS is not as expected
         */
        overflowY: 'auto',
      },
    },
  ],
});

const innerStyle = ({
  theme,
  noPadding,
}: {
  theme: ThemeProps;
  noPadding: Props['noPadding'];
}) => ({
  boxSizing: 'border-box',
  padding: theme.dimension.spacing.s.rem,
  extend: [
    {
      condition: noPadding,
      style: {
        padding: 0,
      },
    },
  ],
});

const LayerContent = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, scrollable = true, noPadding = false, style } = props;
  const { css } = useFela({ scrollable, noPadding });
  return (
    <div
      ref={ref}
      data-dmid="layer-content"
      className={css([contentStyle, style])}>
      <div data-dmid="layer-content-inner" className={css(innerStyle)}>
        {children}
      </div>
    </div>
  );
});

LayerContent.defaultProps = {
  scrollable: true,
};

export default LayerContent;
